// import {MANUAL_SORTING} from "./sorting-manager/options";

import {SortingManagerMode} from "../../manager/sorting-manager/@types";
import {SystemColumnType} from "../../manager/columns/types";

const viewMapDefaultAppSettings = {
    columns                 : _.map([
        SystemColumnType.LOCATION,
        SystemColumnType.TITLE,
        SystemColumnType.STATUS,
    ], id=>({id: id/*, aggregate: null*/})),
    systemStatusFilter      : 'open',
    defaultAddressFieldId   : null,
    zoom                    : 0.67,
    sorting                 : {
        mode: SortingManagerMode.CUSTOM
    },
    filters                 : {},

    taskItemColorFieldId    : 'statusId',

    itemIcons               : [1] //ITEM_TYPE_PROJECT (EntityType.PROJECT), ITEM_TYPE_EVENT (EntityType.EVENT)
}

export default viewMapDefaultAppSettings
